function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionTagRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10a1 1 0 110-2 1 1 0 010 2zm0-4a3 3 0 100 6 3 3 0 000-6zM29.396 16l-1.37-1.371-1.415 1.414 1.372 1.37a.062.062 0 010 .087L17.5 27.982h-.085l-1.372-1.371-1.414 1.414L16 29.395a2.05 2.05 0 001.457.605c.527 0 1.055-.201 1.459-.604l10.48-10.482a2.06 2.06 0 000-2.914z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14.569V4.06A.06.06 0 014.061 4h10.507l9.215 9.214-10.568 10.57L4 14.569zm21.197.06l1.414-1.415-1.414-1.414L15.396 2H4.061A2.06 2.06 0 002 4.06v11.337L13.215 26.61l1.414-1.413 10.568-10.569z",
    fill: props.color
  }));
}

export default SvgIconPromotionTagRexOutline;